import { MapPin, Video } from 'lucide-react';
import { meetingModeLabel, normalizeMeetingMode } from '../../utils/signupSlots';

/**
 * How a meeting is held, as a small pill. Renders nothing for a slot with no mode — those predate
 * per-slot modes and have always shown no badge.
 */
export function MeetingModeBadge({ mode, className = '' }: { mode: string | null | undefined; className?: string }) {
  const normalized = normalizeMeetingMode(mode);
  if (!normalized) return null;

  const isMeet = normalized === 'google_meet';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${
        isMeet ? 'bg-indigo-50 text-indigo-700' : 'bg-emerald-50 text-emerald-700'
      } ${className}`}
    >
      {isMeet ? <Video className="h-3 w-3" aria-hidden /> : <MapPin className="h-3 w-3" aria-hidden />}
      {meetingModeLabel(normalized)}
    </span>
  );
}
